// extracted by mini-css-extract-plugin
module.exports = {"btn":"logout_btn__WNQvX","mobile__btn":"logout_mobile__btn__2pbg7"};